import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

import type { PartyShellPalette } from "../theme/theme";

type Props = {
  url: string;
  partyPal: PartyShellPalette;
};

const PartyCastQrPanel: React.FC<Props> = ({ url, partyPal }) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" spacing={2} sx={{ width: "100%", py: 2 }}>
      <Typography className="party-mono" sx={{ fontSize: 12, color: partyPal.inkDim, letterSpacing: "0.14em", textAlign: "center" }}>
        {t("party.cast.qrTitle")}
      </Typography>
      <Box
        sx={{
          p: 2,
          borderRadius: 3,
          bgcolor: "#fff",
          boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
        }}
      >
        <QRCode value={url} size={220} level="M" />
      </Box>
      <Typography sx={{ fontSize: 13, color: partyPal.hot, textAlign: "center", maxWidth: 320, px: 1, lineHeight: 1.45 }}>
        {t("party.cast.qrHint")}
      </Typography>
    </Stack>
  );
};

export default PartyCastQrPanel;
